import { render, staticRenderFns } from "./RecommendedMadrillas.vue?vue&type=template&id=335822e0"
import script from "./RecommendedMadrillas.vue?vue&type=script&lang=js"
export * from "./RecommendedMadrillas.vue?vue&type=script&lang=js"
import style0 from "./RecommendedMadrillas.vue?vue&type=style&index=0&id=335822e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports